import type { EnvBasedConfigApi } from "@/constants/env-based-config.constant";
import { apiConfigLocalWebExperience } from "./api-config-local-web-experience";
import { ORIGIN } from "@/constants/origin.constant";
import { WEB_EXPERIENCE } from "@/constants/endpoints.constant";

export const apiConfigHttpsLocalWebExperience: EnvBasedConfigApi = {
  ...apiConfigLocalWebExperience,
  webExperience: `${ORIGIN.local}${WEB_EXPERIENCE}`,
};
